import { render, staticRenderFns } from "./centralextrapage.vue?vue&type=template&id=f31d0baa&scoped=true&"
import script from "./centralextrapage.vue?vue&type=script&lang=js&"
export * from "./centralextrapage.vue?vue&type=script&lang=js&"
import style0 from "./centralextrapage.vue?vue&type=style&index=0&id=f31d0baa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31d0baa",
  null
  
)

export default component.exports